export const epochTime = (time) => {
    return(
        Date.parse(time)
    )
}